<template>
  <div v-if="visible" class="profit-loss-modal-overlay" @click="handleOverlayClick">
    <div class="profit-loss-modal" @click.stop>
      <div class="profit-loss-modal-header">
        <h3>{{ dynamicTitle }}</h3>
        <button type="button" class="profit-loss-close-btn" @click="handleClose">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="profit-loss-modal-content">
        <div class="profit-loss-card" :class="profitLossData?.type">
          <div class="profit-loss-header">
            <i class="bi" :class="{
              'bi-arrow-up-circle-fill text-success': profitLossData?.type === 'profit',
              'bi-arrow-down-circle-fill text-danger': profitLossData?.type === 'loss',
              'bi-dash-circle-fill text-warning': profitLossData?.type === 'break-even'
            }"></i>
            <span class="profit-loss-title">{{ profitLossData?.message }}</span>
          </div>
          <div class="profit-loss-details">
            <div class="profit-loss-item">
              <span class="profit-loss-label">Amount:</span>
              <span class="profit-loss-value">${{ profitLossData?.amount }}</span>
            </div>
            <div class="profit-loss-item">
              <span class="profit-loss-label">Percentage:</span>
              <span class="profit-loss-value">{{ profitLossData?.percentage }}%</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showCountdown" class="profit-loss-modal-footer">
        <p class="profit-loss-auto-close-text">This modal will close automatically in {{ countdown }} seconds</p>
      </div>
    </div>
  </div>
</template>

<script>
import './ProfitLossModal.css';

export default {
  name: 'ProfitLossModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    profitLossData: {
      type: Object,
      required: true,
      validator(value) {
        return value && typeof value === 'object' && 
               ['type', 'amount', 'percentage', 'message'].every(key => key in value);
      }
    },
    title: {
      type: String,
      default: 'Profit/Loss Analysis'
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    autoCloseDelay: {
      type: Number,
      default: 5
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      countdown: this.autoCloseDelay,
      timer: null,
      showCountdown: this.autoClose
    };
  },
  computed: {
    dynamicTitle() {
      if (this.profitLossData && this.profitLossData.type) {
        const type = this.profitLossData.type;
        if (type === 'profit') {
          return 'Profit Analysis';
        } else if (type === 'loss') {
          return 'Loss Analysis';
        } else if (type === 'break-even') {
          return 'Break-Even Analysis';
        }
      }
      return this.title; // Fallback to prop title
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.startCountdown();
      } else {
        this.clearTimer();
      }
    },
    autoCloseDelay(newValue) {
      this.countdown = newValue;
    }
  },
  methods: {
    startCountdown() {
      if (!this.autoClose) return;
      
      this.countdown = this.autoCloseDelay;
      this.showCountdown = true;
      
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.handleClose();
        }
      }, 1000);
    },
    
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.countdown = this.autoCloseDelay;
    },
    
    handleClose() {
      this.clearTimer();
      this.$emit('close');
    },
    
    handleOverlayClick() {
      if (this.closeOnOverlayClick) {
        this.handleClose();
      }
    }
  },
  beforeUnmount() {
    this.clearTimer();
  }
};
</script>

